export function checkLocal() {
    const countryLocals = {
        'bg-BG': [2, 'Europe'],
        'cy-CY': [2, 'Europe'],
        'hr-HR': [1, 'Europe'],
        'hu-HU': [1, 'Europe'],
        'el-GR': [2, 'Europe'],
        'fi-FI': [2, 'Europe'],
        'ro-RO': [2, 'Europe'],
        'pl-PL': [1, 'Europe'],
        'is-IS': [1, 'Europe'],
        'lt-LT': [2, 'Europe'],
        'lv-LV': [2, 'Europe'],
        'mt-MT': [1, 'Europe'],
        'si-SI': [1, 'Europe'],
        'sk-SK': [1, 'Europe'],
        'da-DK': [1, 'Europe'],
        'ee-EE': [2, 'Europe'],
        'en-GB': [0, 'Europe'],
        'en-AU': [10, 'Australia'],
        'en-AE': [4, 'Dubai'],
        'ar-AE': [4, 'Dubai'],
        'de-AT': [1, 'Europe'],
        'zh-TW': [10, 'Australia'],
        'zh-CN': [8, 'HongKong'],
        'fr-LU': [1, 'Europe'],
        'nl-NL': [1, 'Europe'],
        'it-IT': [1, 'Europe'],
        'ja-JP': [9, 'Tokyo'],
        'en-SG': [8, 'Singapore'],
        'en-ZA': [2, 'South Africa'],
        'no-NO': [1, 'Europe'],
        'pt-PT': [0, 'Europe'],
        'es-ES': [1, 'Europe'],
        'sv-SE': [1, 'Europe'],
        'fr-FR': [1, 'Europe'],
        'de-DE': [1, 'Europe'],
        'de-CH': [1, 'Europe'],
        'en-CH': [1, 'Europe'],
        'fr-CH': [1, 'Europe'],
        'it-CH': [1, 'Europe'],
    };
    const langAttr = document.querySelector('html').getAttribute('lang');
    return countryLocals[langAttr] || [0, 'Europe'];
};
